import { render, staticRenderFns } from "./IncomeReport.vue?vue&type=template&id=3ef2b465&"
import script from "./IncomeReport.vue?vue&type=script&lang=js&"
export * from "./IncomeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports